<template>
  <div class="dashboard">
    <div class="dashboard-grid">
      <yard-notification-document-list v-if="visibleSections.includes(TEAM_SECTIONS_YARD_KEY)" class="grid-full" :isDetail="true"/>
      <yard-gantt  v-if="visibleSections.includes(TEAM_SECTIONS_YARD_KEY)" class="grid-full" :isDetail="true"/>
      <downloads-list class="grid-full" :isDetail="true"/>
      <agreement-document-list
        v-if="visibleSections.includes(TEAM_SECTIONS_AGREEMENT_KEY)"
        :class="visibleSections.includes(TEAM_SECTIONS_CONSULTING_KEY) ? 'grid-half': 'grid-full'"
        :isDetail="true"
      />
      <upload-document-list
        v-if="visibleSections.includes(TEAM_SECTIONS_CONSULTING_KEY)"
        :class="visibleSections.includes(TEAM_SECTIONS_AGREEMENT_KEY) ? 'grid-half': 'grid-full'"
        :isDetail="true"
      />
      <eligibility-list  v-if="visibleSections.includes(TEAM_SECTIONS_CONSULTING_KEY)" class="grid-half" :isDetail="true"/>
      <unilav-list  v-if="visibleSections.includes(TEAM_SECTIONS_CONSULTING_KEY)" class="grid-half" :isDetail="true"/>
      <training-accordion  v-if="visibleSections.includes(TEAM_SECTIONS_TRAINING_KEY)" class="grid-full"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import YardNotificationDocumentList from '../yard-notification-document/YardNotificationDocumentList.vue'
import YardGantt from '../yard-gantt/YardGanttList.vue'
import AgreementDocumentList from '../agreement-document/AgreementDocumentList.vue'
import UploadDocumentList from '../upload-document/UploadDocumentList.vue'
import EligibilityList from '../eligibility/EligibilityList.vue'
import DownloadsList from '../downloads/DownloadsList.vue'
import UnilavList from '../unilav/UnilavList.vue'
import TrainingAccordion from '../training/TrainingAccordion.vue'

import { TEAM_SECTIONS_CONSULTING_KEY, TEAM_SECTIONS_TRAINING_KEY, TEAM_SECTIONS_YARD_KEY, TEAM_SECTIONS_AGREEMENT_KEY } from '@/const'

export default {
  name: 'dashboard',
  components: {
    YardNotificationDocumentList,
    AgreementDocumentList,
    UploadDocumentList,
    EligibilityList,
    UnilavList,
    TrainingAccordion,
    YardGantt,
    DownloadsList
  },
  data: () => ({
    dataset: [],
    resultset: [],
    displayRange: 3,
    TEAM_SECTIONS_CONSULTING_KEY,
    TEAM_SECTIONS_TRAINING_KEY,
    TEAM_SECTIONS_YARD_KEY,
    TEAM_SECTIONS_AGREEMENT_KEY
  }),
  computed: {
    ...mapGetters({
      me: 'auth/me',
      profile: 'auth/profile'
    }),
    visibleSections () {
      return (this.me && this.me.visible_team_sections) || []
    }
  }
}
</script>
